// import React, { useEffect, useState } from "react";
// import "./EntryFormReport.scss";
// import { TitleBar } from "../../../Global/TitleBar/TitleBar";
// import { TopBar } from "../../TopBar/TopBar";
// import {
//   Description,
//   GreenSubDescription,
//   PaymentPendingHeading,
// } from "../../../Global/GlobalText";
// import { IoMdArrowDropleft, IoMdArrowDropright } from "react-icons/io";
// import { CheckboxInput } from "../../../Global/GlobalFormElement";
// import { RxCrossCircled } from "react-icons/rx";
// import axios from "axios";
// import { EXCHNAGE_URL } from "../../../../Url/Url";
// import { toast } from "react-toastify";
// import { useSelector } from "react-redux";
// import { RedBackgroundButton } from "../../../Global/GlobalButton";

// export const EntryFormReport = () => {
//   const [availableFields, setAvailableFields] = useState([]);
//   const [selectedFields, setSelectedFields] = useState([]);
//   const [availableCheckboxes, setAvailableCheckboxes] = useState({});
//   const [selectedCheckboxes, setSelectedCheckboxes] = useState({});

//   const token = localStorage.getItem("token");
//   const eventIdGet = useSelector((state) => state?.users?.id);
//   const eventId = String(eventIdGet);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           `https://api.awardsuite.in/api/admin/fetchFormFields?eventId=${eventId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         const data = response.data;

//         if (data.status && data.formSchema?.entryFields) {
//           setAvailableFields(data.formSchema.entryFields);
//           const checkboxes = {};
//           data.formSchema.entryFields.forEach((field) => {
//             checkboxes[field.field_name] = false;
//           });
//           setAvailableCheckboxes(checkboxes);
//         } else {
//           throw new Error("Invalid API response format");
//         }
//       } catch (error) {
//         console.error("Error fetching form fields:", error);
//         toast.error("Failed to fetch form fields");
//       }
//     };

//     fetchData();
//   }, [eventId]);

//   const handleCheckboxChange = (key, section) => {
//     if (section === "available") {
//       setAvailableCheckboxes((prev) => ({
//         ...prev,
//         [key]: !prev[key],
//       }));
//     } else {
//       setSelectedCheckboxes((prev) => ({
//         ...prev,
//         [key]: !prev[key],
//       }));
//     }
//   };

//   const moveToSelected = () => {
//     const moving = availableFields.filter(
//       (field) => availableCheckboxes[field.field_name]
//     );
//     if (moving.length === 0) return;

//     setSelectedFields((prev) => [...prev, ...moving]);
//     setAvailableFields((prev) =>
//       prev.filter((field) => !availableCheckboxes[field.field_name])
//     );

//     const updatedCheckboxes = { ...availableCheckboxes };
//     moving.forEach((field) => {
//       delete updatedCheckboxes[field.field_name];
//     });
//     setAvailableCheckboxes(updatedCheckboxes);
//   };

//   const moveToAvailable = () => {
//     const moving = selectedFields.filter(
//       (field) => selectedCheckboxes[field.field_name]
//     );
//     if (moving.length === 0) return;

//     setAvailableFields((prev) => [...prev, ...moving]);
//     setSelectedFields((prev) =>
//       prev.filter((field) => !selectedCheckboxes[field.field_name])
//     );

//     const updatedCheckboxes = { ...selectedCheckboxes };
//     moving.forEach((field) => {
//       delete updatedCheckboxes[field.field_name];
//     });
//     setSelectedCheckboxes(updatedCheckboxes);
//   };

//   const handleSelectAllAvailable = () => {
//     const updated = {};
//     availableFields.forEach((field) => {
//       updated[field.field_name] = true;
//     });
//     setAvailableCheckboxes(updated);
//   };

//   const handleDeselectAllAvailable = () => {
//     const updated = {};
//     availableFields.forEach((field) => {
//       updated[field.field_name] = false;
//     });
//     setAvailableCheckboxes(updated);
//   };

//   const handleSelectAllSelected = () => {
//     const updated = {};
//     selectedFields.forEach((field) => {
//       updated[field.field_name] = true;
//     });
//     setSelectedCheckboxes(updated);
//   };

//   const handleDeselectAllSelected = () => {
//     const updated = {};
//     selectedFields.forEach((field) => {
//       updated[field.field_name] = false;
//     });
//     setSelectedCheckboxes(updated);
//   };

//   const handleSubmitSelectedColumns = async () => {
//     const selectedColumnNames = selectedFields.map((field) => field.field_name);
//     const selectedColumnLabels = selectedFields.map((field) => field.label);

//     const payload = {
//       eventId,
//       selectedColumns: selectedColumnNames,
//       selectedLabels: selectedColumnLabels,
//     };

//     try {
//       const response = await axios.post(`${EXCHNAGE_URL}/download1`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//         responseType: "blob",
//       });

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", "entry_data.xlsx");
//       document.body.appendChild(link);
//       link.click();
//       link.remove();

//       toast.success("File downloaded successfully!");
//     } catch (error) {
//       console.error("Error downloading file:", error);
//       toast.error("Error downloading file.");
//     }
//   };

//   return (
//     <div>
//       <div className="entryformreport_data_div">
//         <TitleBar title="Entry Form Report" />
//         <div className="entryformreport_white_bg">
//           <TopBar titleheading="Entry Form Report" />

//           <div className="entryformreport_main">
//             <GreenSubDescription>
//               Select and Re-arrange your columns
//             </GreenSubDescription>

//             <div className="entryformreport_column_head">
//               <PaymentPendingHeading>Available Columns</PaymentPendingHeading>
//               <div className="entryformreport_arrow_icon">
//                 <IoMdArrowDropleft onClick={moveToAvailable} />
//                 <IoMdArrowDropright onClick={moveToSelected} />
//               </div>
//               <PaymentPendingHeading>Selected Columns</PaymentPendingHeading>
//             </div>

//             <div className="entryformreport_check_section">
//               <div className="entryformreport_sub_check" style={{ backgroundColor: "#FFE2E54D" }}>
//                 <div className="entryformreport_heading">
//                   <h4 onClick={handleSelectAllAvailable}>Select All</h4>
//                   <h4 onClick={handleDeselectAllAvailable}>Deselect All</h4>
//                 </div>
//                 <div className="entryformreport_checbox_div">
//                   {availableFields.map((field) => (
//                     <div key={field.field_name}>
//                       <CheckboxInput
//                         type="checkbox"
//                         checked={availableCheckboxes[field.field_name] || false}
//                         onChange={() => handleCheckboxChange(field.field_name, "available")}
//                       />
//                       <label>{field.label}</label>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               <div className="entryformreport_sub_check" style={{ backgroundColor: "#F6F8F9" }}>
//                 <div className="entryformreport_heading">
//                   <h4 onClick={handleSelectAllSelected}>Select All</h4>
//                   <h4 onClick={handleDeselectAllSelected}>Deselect All</h4>
//                 </div>
//                 <div className="entryformreport_newchecbox_div">
//                   {selectedFields.map((field) => (
//                     <div key={field.field_name}>
//                       <CheckboxInput
//                         type="checkbox"
//                         checked={selectedCheckboxes[field.field_name] || false}
//                         onChange={() => handleCheckboxChange(field.field_name, "selected")}
//                       />
//                       <label>{field.label}</label>
//                       <RxCrossCircled
//                         onClick={() => {
//                           setSelectedFields((prev) =>
//                             prev.filter((f) => f.field_name !== field.field_name)
//                           );
//                           setAvailableFields((prev) => [...prev, field]);
//                           setSelectedCheckboxes((prev) => {
//                             const updated = { ...prev };
//                             delete updated[field.field_name];
//                             return updated;
//                           });
//                           setAvailableCheckboxes((prev) => ({
//                             ...prev,
//                             [field.field_name]: false,
//                           }));
//                         }}
//                         style={{ cursor: "pointer", color: "#333", marginLeft: "10px" }}
//                       />
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <RedBackgroundButton style={{ marginLeft: "1rem" }} onClick={handleSubmitSelectedColumns}>
//         Download Selected Columns
//       </RedBackgroundButton>
//     </div>
//   );
// };
import React, { useEffect, useState } from "react";
import "./EntryFormReport.scss";
import { TitleBar } from "../../../Global/TitleBar/TitleBar";
import { TopBar } from "../../TopBar/TopBar";
import {
  Description,
  GreenSubDescription,
  PaymentPendingHeading,
} from "../../../Global/GlobalText";
import { IoMdArrowDropleft, IoMdArrowDropright } from "react-icons/io";
import { CheckboxInput } from "../../../Global/GlobalFormElement";
import { RxCrossCircled } from "react-icons/rx";
import axios from "axios";
import { EXCHNAGE_URL } from "../../../../Url/Url";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RedBackgroundButton } from "../../../Global/GlobalButton";

export const EntryFormReport = () => {
  const [availableFields, setAvailableFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [availableCheckboxes, setAvailableCheckboxes] = useState({});
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});

  // ✅ Helper function to check if label contains HTML
  const containsHTML = (text) => /<[a-z][\s\S]*>/i.test(text);

  const token = localStorage.getItem("token");
  const eventIdGet = useSelector((state) => state?.users?.id);
  const eventId = String(eventIdGet);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://api.awardsuite.in/api/admin/fetchFormFields?eventId=${eventId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = response.data;

        if (data.status && data.formSchema?.entryFields) {
          setAvailableFields(data.formSchema.entryFields);
          const checkboxes = {};
          data.formSchema.entryFields.forEach((field) => {
            checkboxes[field.field_name] = false;
          });
          setAvailableCheckboxes(checkboxes);
        } else {
          throw new Error("Invalid API response format");
        }
      } catch (error) {
        console.error("Error fetching form fields:", error);
        toast.error("Failed to fetch form fields");
      }
    };

    fetchData();
  }, [eventId]);

  const handleCheckboxChange = (key, section) => {
    if (section === "available") {
      setAvailableCheckboxes((prev) => ({
        ...prev,
        [key]: !prev[key],
      }));
    } else {
      setSelectedCheckboxes((prev) => ({
        ...prev,
        [key]: !prev[key],
      }));
    }
  };

  const moveToSelected = () => {
    const moving = availableFields.filter(
      (field) => availableCheckboxes[field.field_name]
    );
    if (moving.length === 0) return;

    setSelectedFields((prev) => [...prev, ...moving]);
    setAvailableFields((prev) =>
      prev.filter((field) => !availableCheckboxes[field.field_name])
    );

    const updatedCheckboxes = { ...availableCheckboxes };
    moving.forEach((field) => {
      delete updatedCheckboxes[field.field_name];
    });
    setAvailableCheckboxes(updatedCheckboxes);
  };

  const moveToAvailable = () => {
    const moving = selectedFields.filter(
      (field) => selectedCheckboxes[field.field_name]
    );
    if (moving.length === 0) return;

    setAvailableFields((prev) => [...prev, ...moving]);
    setSelectedFields((prev) =>
      prev.filter((field) => !selectedCheckboxes[field.field_name])
    );

    const updatedCheckboxes = { ...selectedCheckboxes };
    moving.forEach((field) => {
      delete updatedCheckboxes[field.field_name];
    });
    setSelectedCheckboxes(updatedCheckboxes);
  };

  const handleSelectAllAvailable = () => {
    const updated = {};
    availableFields.forEach((field) => {
      updated[field.field_name] = true;
    });
    setAvailableCheckboxes(updated);
  };

  const handleDeselectAllAvailable = () => {
    const updated = {};
    availableFields.forEach((field) => {
      updated[field.field_name] = false;
    });
    setAvailableCheckboxes(updated);
  };

  const handleSelectAllSelected = () => {
    const updated = {};
    selectedFields.forEach((field) => {
      updated[field.field_name] = true;
    });
    setSelectedCheckboxes(updated);
  };

  const handleDeselectAllSelected = () => {
    const updated = {};
    selectedFields.forEach((field) => {
      updated[field.field_name] = false;
    });
    setSelectedCheckboxes(updated);
  };

  // ✅ Helper to render label with HTML support
  const renderLabel = (label) => {
    return containsHTML(label) ? (
      <span 
        className="form-label-html"
        dangerouslySetInnerHTML={{ __html: label }} 
      />
    ) : (
      label
    );
  };

  const handleSubmitSelectedColumns = async () => {
    const selectedColumnNames = selectedFields.map((field) => field.field_name);
    const selectedColumnLabels = selectedFields.map((field) => field.label);

    const payload = {
      eventId,
      selectedColumns: selectedColumnNames,
      selectedLabels: selectedColumnLabels,
    };

    try {
      const response = await axios.post(`${EXCHNAGE_URL}/download1`, payload, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "entry_data.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("File downloaded successfully!");
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.error("Error downloading file.");
    }
  };

  return (
    <div>
      <div className="entryformreport_data_div">
        <TitleBar title="Entry Form Report" />
        <div className="entryformreport_white_bg">
          <TopBar titleheading="Entry Form Report" />

          <div className="entryformreport_main">
            <GreenSubDescription>
              Select and Re-arrange your columns
            </GreenSubDescription>

            <div className="entryformreport_column_head">
              <PaymentPendingHeading>Available Columns</PaymentPendingHeading>
              <div className="entryformreport_arrow_icon">
                <IoMdArrowDropleft onClick={moveToAvailable} />
                <IoMdArrowDropright onClick={moveToSelected} />
              </div>
              <PaymentPendingHeading>Selected Columns</PaymentPendingHeading>
            </div>

            <div className="entryformreport_check_section">
              <div className="entryformreport_sub_check" style={{ backgroundColor: "#FFE2E54D" }}>
                <div className="entryformreport_heading">
                  <h4 onClick={handleSelectAllAvailable}>Select All</h4>
                  <h4 onClick={handleDeselectAllAvailable}>Deselect All</h4>
                </div>
                <div className="entryformreport_checbox_div">
                  {availableFields.map((field) => (
                    <div key={field.field_name} className="entryformreport_checkbox_item">
                      <CheckboxInput
                        type="checkbox"
                        checked={availableCheckboxes[field.field_name] || false}
                        onChange={() => handleCheckboxChange(field.field_name, "available")}
                      />
                      <label>
                        {renderLabel(field.label)}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div className="entryformreport_sub_check" style={{ backgroundColor: "#F6F8F9" }}>
                <div className="entryformreport_heading">
                  <h4 onClick={handleSelectAllSelected}>Select All</h4>
                  <h4 onClick={handleDeselectAllSelected}>Deselect All</h4>
                </div>
                <div className="entryformreport_newchecbox_div">
                  {selectedFields.map((field) => (
                    <div key={field.field_name} className="entryformreport_checkbox_item selected-item">
                      <CheckboxInput
                        type="checkbox"
                        checked={selectedCheckboxes[field.field_name] || false}
                        onChange={() => handleCheckboxChange(field.field_name, "selected")}
                      />
                      <label>
                        {renderLabel(field.label)}
                      </label>
                      <RxCrossCircled
                        onClick={() => {
                          setSelectedFields((prev) =>
                            prev.filter((f) => f.field_name !== field.field_name)
                          );
                          setAvailableFields((prev) => [...prev, field]);
                          setSelectedCheckboxes((prev) => {
                            const updated = { ...prev };
                            delete updated[field.field_name];
                            return updated;
                          });
                          setAvailableCheckboxes((prev) => ({
                            ...prev,
                            [field.field_name]: false,
                          }));
                        }}
                        className="remove-icon"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <RedBackgroundButton 
        style={{ marginLeft: "1rem", marginTop: "1rem" }} 
        onClick={handleSubmitSelectedColumns}
        disabled={selectedFields.length === 0}
      >
        Download Selected Columns ({selectedFields.length})
      </RedBackgroundButton>
    </div>
  );
};